import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { jdConfig, jobsConfig, myJobsConfig } from './constants';
import { jdTheme, jobsTheme, myJobsTheme } from './constants/theme';
import JdApp from './jd-app';
import JobApp from './job-app';
import MyJobsApp from './my-job-app';
function App() {
    return (_jsx(Router, { children: _jsx(Routes, { children: _jsxs(Route, { path: '/', element: _jsx(Layout, {}), children: [_jsx(Route, { index: true, element: _jsx(JobApp, { theme: jobsTheme, config: jobsConfig }) }), _jsx(Route, { path: 'job/:jobId/:slug', element: _jsx(JdApp, { theme: jdTheme, config: jdConfig }) }), _jsx(Route, { path: 'my-jobs', element: _jsx(MyJobsApp, { theme: myJobsTheme, config: myJobsConfig }) }), _jsx(Route, { path: '*', element: _jsx(JobApp, { theme: jobsTheme, config: jobsConfig }) })] }) }) }));
}
function Layout() {
    return _jsx(Outlet, {});
}
export default App;
